export default "__VITE_ASSET__CaTe7qNJ__"